import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { ContentLayoutComponent } from './shared/components/layout/content-layout/content-layout.component';
import { content } from "./shared/routes/content-routes";
import { AdminGuard } from './shared/guard/admin.guard';
import { RegisterWithImageComponent } from './auth/register/register-with-image.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/docsoporte/VPARDOCSOPOR_C/0/A/B/0',
    pathMatch: 'full'
  },
  {
    path: 'auth/login',
    component: LoginComponent
  },
  {
    path: 'auth/register',
    component: RegisterWithImageComponent
  },
  {
    path: 'select-rol',
    loadChildren: () => import('./components/select-rol/select-rol.module').then(m => m.SelectRolModule),
    data: {
      breadcrumb: "Configuracion Inicial"
    }
  },
  {
    path: 'pageV/:ph',
    loadChildren: () => import('./components/page-view/page-view.module').then(m => m.PageViewModule),
  },
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [AdminGuard],
    children: content
  },
  {
    path: '**',
    redirectTo: '/docsoporte/VPARDOCSOPOR_C/0/A/B/0'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
